import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss';
import '../layout/sass/_responsiveTable.scss';
import api from '../api/api';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tag } from 'primereact/tag';
import moment from 'moment';

export const TabelaTurmaMatriculas = ({ turmaMatricula }) => {
  const confirmationToast = useRef(null);
  const toast = useRef(null);
  const [matriculas, setMatriculas] = useState([]);
  const [perfil, setPerfil] = useState([]);
  const [showPerfil, setShowPerfil] = useState(false);
  const [idMatricula, setIdMatricula] = useState();

  const [history, setHistory] = useState(null);
  const [sortNotas, setSortNotas] = useState({
    field: null,
    order: null,
  });

  const [sortFaltas, setSortFaltas] = useState({
    field: 'dataOcorrencia',
    order: -1,
  });

  const [activeTab, setActiveTab] = useState(0);

  const header = (
    <div className="p-grid p-col-12 p-m-0 p-p-0">
      <div>
        <h2 className="p-my-0">Matriculados</h2>
      </div>
    </div>
  );

  const codBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <span className="p-column-title">Código</span>
          <span className="table-data">{rowData.id}</span>
        </p>
      </React.Fragment>
    );
  };

  const nomeBodyTemplate = (rowData) => {
    // Validação segura: verifica se a string existe e não está vazia após remover espaços
    const nomeSocial = rowData.aluno?.nomeSocial;
    const temNomeSocial = nomeSocial && nomeSocial.trim().length > 0;

    return (
      <React.Fragment>
        <div style={{ textAlign: 'left' }} className="flex flex-column gap-1">
          <span className="p-column-title">Nome</span>

          {/* Nome Civil */}
          <span className="table-data block font-medium">
            {rowData.aluno.nome}
          </span>

          {/* Nome Social - Renderiza apenas se existir */}
          {temNomeSocial && (
            <Tag
              value={nomeSocial}
              severity="info"
              style={{ fontSize: '0.75rem', width: 'fit-content' }}
              // icon="pi pi-info-circle"
              className="mt-1"
            />
          )}
        </div>
      </React.Fragment>
    );
  };

  const dataMatriculaBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <span className="p-column-title">Data Matrícula</span>
          <span className="table-data">
            {new Date(rowData.dataMatricula).toLocaleDateString()}
          </span>
        </p>
      </React.Fragment>
    );
  };

  const conclusaoBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <span className="p-column-title">Conclusão</span>
          {rowData.conclusao == null ? (
            <span className="table-data">NÃO CONCLUÍDO</span>
          ) : (
            <span className="table-data">
              {new Date(rowData.conclusao).toLocaleDateString()}
            </span>
          )}
        </p>
      </React.Fragment>
    );
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <span className="p-column-title">Status</span>
          <span className="table-data">{rowData.status}</span>
        </p>
      </React.Fragment>
    );
  };

  const instrumentoBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <span className="p-column-title">Instrumento</span>
          {rowData.instrumento == null ? (
            <span className="table-data">NÃO INFORMADO</span>
          ) : (
            <span className="table-data">{rowData.instrumento.nome}</span>
          )}
        </p>
      </React.Fragment>
    );
  };

  const salaBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <span className="p-column-title">Sala</span>
          <span className="table-data">{rowData.turma.sala}</span>
        </p>
      </React.Fragment>
    );
  };

  const perfilBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <p style={{ textalign: 'left' }}>
          <Button
            icon="pi pi-info"
            className="p-button-rounded p-button-secondary"
            onClick={() => handlePerfilClick(rowData)}
            style={{
              left: '5px',
              bottom: '5px',
              height: '20px',
              width: '20px',
            }}
          />
        </p>
      </React.Fragment>
    );
  };

  const getMatriculas = useCallback(async () => {
    try {
      if (turmaMatricula !== undefined) {
        const response = await api.get(`matricula/turma/${turmaMatricula}`);
        setMatriculas(response.data);
      }
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Erro ao obter matriculas na turma',
        detail: error.toString(),
      });
    }
  }, [turmaMatricula]);

  const getHistory = useCallback(async () => {
    try {
      if (!idMatricula) return;

      const response = await api.get(`matricula/${idMatricula}`);

      const matriculaData = response.data;
      setHistory(matriculaData);
    } catch (error) {
      // ... erro
    }
  }, [idMatricula]);

  const notasMemo = useMemo(() => {
    
    if (!history?.notas) return [];

    return [...history.notas]
      .map((nota) => {
        const notaAluno = nota.notaAluno ?? 0;
        const notaTotal = nota.avaliacaoNotaTotal ?? 0;

        const porcentagem = notaTotal > 0 ? (notaAluno / notaTotal) * 100 : 0;

        let color = 'red';

        if (porcentagem === 100) {
          color = 'green';
        } else if (porcentagem >= 60) {
          color = 'orange';
        }

        return {
          ...nota,
          notaAluno,
          porcentagem,
          color,
        };
      })
      .sort((a, b) => b.notaAluno - a.notaAluno);
  }, [history]);

  const faltasMemo = useMemo(() => {
    if (!history?.faltas) return [];

    return [...history.faltas]
      .filter((item) => item.atraso !== true)
      .sort((a, b) => new Date(b.dataOcorrencia) - new Date(a.dataOcorrencia));
  }, [history]);

  const atrasosMemo = useMemo(() => {
    if (!history?.faltas) return [];

    return [...history.faltas]
      .filter((item) => item.atraso === true)
      .sort((a, b) => new Date(b.dataOcorrencia) - new Date(a.dataOcorrencia));
  }, [history]);

  const totalFaltas = useMemo(() => faltasMemo.length, [faltasMemo]);
  const totalAtrasos = useMemo(() => atrasosMemo.length, [atrasosMemo]);

  const handlePerfilClick = (rowData) => {
    setHistory(null); // Limpa o histórico anterior
    setPerfil(rowData.aluno);
    setIdMatricula(rowData.id);
    setShowPerfil(true);
  };

  useEffect(() => {
    getMatriculas();
  }, [getMatriculas]);


  useEffect(() => {
    if (idMatricula) {
      getHistory();
    }
  }, [idMatricula, getHistory]);

  function formatCpf(data) {
    const cpf =
      data != null
        ? data.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
        : data;

    return cpf;
  }

  return (
    <>
      <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
        <Dialog
          className="p-scrollpanel-bar-y"
          header=""
          onHide={() => setShowPerfil(false)}
          visible={showPerfil}
          breakpoints={{ '960px': '75vw', '640px': '100vw' }}
          style={{ width: '50vw', heigth: '5vw' }}
        >
          <div>
            <div className="p-d-flex p-ai-center p-flex-column header">
              <h2>Perfil</h2>
            </div>
            <br></br>

            <Panel header="Dados do Aluno" style={{ marginBottom: '2rem' }}>
              <div className="p-col-12">
                <b>Nome:</b> {perfil.nome}
              </div>
              <div className="p-col-12">
                <b>CPF:</b> {formatCpf(perfil.cpf)}
              </div>
              <div className="p-col-12">
                <b>Email:</b> {perfil.email}
              </div>
              <div className="p-col-12">
                <b>Data de Nascimento:</b>{' '}
                {new Date(perfil.dataNascimento).toLocaleDateString()}
              </div>
              <div className="p-col-12">
                <b>Deficiência:</b> {perfil.deficiencia}
              </div>
              <div className="p-col-12">
                <b>Responsavel:</b> {perfil.responsavel}
              </div>
              <div className="p-col-12">
                <b>Telefone:</b> {perfil.telefone}
              </div>
              <div className="p-col-12">
                <b>Celular:</b> {perfil.celular}
              </div>
            </Panel>

            <Panel header="Histórico">
              <TabView
                activeIndex={activeTab}
                onTabChange={(e) => {
                  setActiveTab(e.index);
                  setSortNotas({ field: null, order: null });
                  setSortFaltas({ field: null, order: null });
                }}
              >
                <TabPanel header="Notas">
                  <DataTable
                    value={notasMemo}
                    paginator
                    rows={5}
                    responsiveLayout="scroll"
                    emptyMessage="Nenhuma nota encontrada"
                    sortField={sortNotas.field}
                    sortOrder={sortNotas.order}
                    onSort={(e) =>
                      setSortNotas({
                        field: e.sortField,
                        order: e.sortOrder,
                      })
                    }
                  >
                    <Column field="avaliacaoTipo.nome" header="Avaliação" />
                    <Column
                      field="notaAluno"
                      header="Nota do Aluno"
                      sortable
                      body={(row) => (
                        <span
                          style={{
                            color: row.color,
                            fontWeight: 600,
                          }}
                        >
                          {row.notaAluno}
                        </span>
                      )}
                    />
                    <Column
                      field="avaliacaoNotaTotal"
                      header="Nota da Avaliação"
                    />
                    <Column
                      field="avaliacaoData"
                      header="Data"
                      body={(row) =>
                        new Date(row.avaliacaoData).toLocaleDateString('pt-BR')
                      }
                    />
                  </DataTable>
                </TabPanel>
                <TabPanel header="Faltas">
                  <DataTable
                    value={faltasMemo}
                    paginator
                    rows={5}
                    emptyMessage="Nenhuma falta registrada"
                    footer={`Total de faltas: ${totalFaltas}`}
                    sortField={sortFaltas.field}
                    sortOrder={sortFaltas.order}
                    onSort={(e) =>
                      setSortFaltas({
                        field: e.sortField,
                        order: e.sortOrder,
                      })
                    }
                  >
                    <Column
                      field="dataOcorrencia"
                      header="Data"
                      sortable
                      body={(row) =>
                        moment(row.dataOcorrencia, 'YYYY-MM-DD').format(
                          'DD/MM/YYYY'
                        )
                      }
                    />
                    <Column field="obs" header="Observação" />
                  </DataTable>
                </TabPanel>
                <TabPanel header="Atrasos">
                  <DataTable
                    value={atrasosMemo}
                    paginator
                    rows={5}
                    emptyMessage="Nenhum atraso registrado"
                    footer={`Total de atrasos: ${totalAtrasos}`}
                    sortField={sortFaltas.field}
                    sortOrder={sortFaltas.order}
                    onSort={(e) =>
                      setSortFaltas({
                        field: e.sortField,
                        order: e.sortOrder,
                      })
                    }
                  >
                    <Column
                      field="dataOcorrencia"
                      header="Data"
                      sortable
                      body={(row) =>
                        moment(row.dataOcorrencia, 'YYYY-MM-DD').format(
                          'DD/MM/YYYY'
                        )
                      }
                    />
                    <Column field="obs" header="Observação" />
                  </DataTable>
                </TabPanel>
              </TabView>
            </Panel>
          </div>
        </Dialog>

        <Toast ref={toast} position="bottom-right" />

        <Toast ref={confirmationToast} position="bottom-center" />

        <div className="card p-col-12 datatable-responsive-demo">
          <div className="p-fluid">
            <DataTable
              style={{ width: '100%' }}
              lazy="true"
              onPage={getMatriculas}
              header={header}
              value={matriculas}
              filterDisplay="row"
              className="p-datatable-responsive-demo"
              emptyMessage="Nenhuma matrícula encontrada"
              dataKey="id"
              rows={50}
            >
              <Column
                style={{ width: '5%' }}
                field="id"
                header="Código"
                body={codBodyTemplate}
              />

              <Column
                style={{ width: '15%' }}
                field="aluno.nome"
                header="Nome"
                body={nomeBodyTemplate}
              />

              <Column
                style={{ width: '10%' }}
                field="dataMatricula"
                header="Data Matrícula"
                body={dataMatriculaBodyTemplate}
              />

              <Column
                style={{ width: '10%' }}
                field="conclusao"
                header="Conclusão"
                body={conclusaoBodyTemplate}
              />

              <Column
                style={{ width: '15%' }}
                field="status"
                header="Status"
                body={statusBodyTemplate}
              />

              <Column
                style={{ width: '15%' }}
                field="instrumento.nome"
                header="Instrumento"
                body={instrumentoBodyTemplate}
              />

              <Column
                style={{ width: '5%' }}
                field="turma"
                header="Sala"
                body={salaBodyTemplate}
              />

              <Column
                style={{ width: '5%' }}
                field="perfil"
                header="Perfil"
                body={perfilBodyTemplate}
              />
            </DataTable>
          </div>
        </div>
      </div>
    </>
  );
};
